import { Component, Input, forwardRef, Output, EventEmitter  } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    }
  ]
})
export class DropdownComponent implements ControlValueAccessor {

  @Input() placeholder;
  @Input() label;
  @Input() item: any;
  @Input() disable: boolean;
  /**
   * Event emiiter for
   * Schedule appointment
   */
  @Output() selectChange: EventEmitter<any> = new EventEmitter<any>();

  value: any;


  onChange: any = (value: any) => { };
  onTouched: any = () => { };

  constructor() { }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    this.value = value;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  itemChange(item, index = null) {
    this.value = item;
    this.onChange(item);
    this.placeholder = item;

    this.selectChange.emit({index, item});
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/dropdown.component.ts